import { Overrides } from '@material-ui/core/styles/overrides';
import { CORPORATE_COLORS } from '@Ui/theme/colors/corporate';

export const buttonOverrides: Overrides = {
  MuiButton: {
    root: {
      textTransform: 'none',
      height: '54px',
      color: CORPORATE_COLORS.BLUE,
      borderRadius: '5px'
    },

    label: {
      fontSize: '16px',
      color: CORPORATE_COLORS.WHITE
    },

    containedPrimary: {
      backgroundColor: CORPORATE_COLORS.PRIMARY,
      height: '54px',
      padding: '20px',
      borderRadius: '40px',
      boxShadow: 'none',

      '&:hover': {
        backgroundColor: CORPORATE_COLORS.PRIMARY
      }
    },

    outlined: {
      color: CORPORATE_COLORS.BLUE,
      borderStyle: 'solid',
      borderColor: CORPORATE_COLORS.BLUE,
      borderWidth: '2px',

      '&:hover': {
        borderColor: CORPORATE_COLORS.DARK_BLUE,
        backgroundColor: CORPORATE_COLORS.DARK_BLUE,
        color: CORPORATE_COLORS.WHITE
      }
    }
  }
};
